import React from "react";
import { asset } from "./landingAssets";

const LandingPage = () => {
  // Ciclo de facturación de la grilla de planes (Mensual/Anual −20%).
  const [cycle, setCycle] = React.useState("monthly");
  const annual = cycle === "annual";
  return (
  <div className="landing-page">

      <h1 className="visually-hidden">Voras | WMS para E-commerce y Control de Stock en Tiempo Real</h1>

      <nav className="navbar">
        <div className="nav-inner">
          <div className="nav-logo">
            <img src={asset("iconos/logo.webp")} alt="Voras" width="43" height="42" />
          </div>
          <div className="nav-links" id="navLinks">
            <a href="#nosotros">Nosotros</a>
            <a href="#propuesta">Propuesta</a>
            <a href="#funcionalidades">Funcionalidades</a>
            <a href="#planes">Planes</a>
            <a href="/login">Iniciar sesión</a>
          </div>
          <div className="nav-buttons">
            <a href="/registro" className="btn-primary" data-fb-event="CompleteRegistration">Registrarse</a>
            <a href="#demo" className="btn-secondary">Agendar Demo</a>
          </div>
          <button className="hamburger" id="hamburger" type="button" aria-label="Abrir menú" aria-expanded="false" aria-controls="navLinks">
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <div className="page">

        <section className="slider">
          <picture className="slider-bg">
            <source
              media="(max-width: 768px)"
              srcSet={asset("imagenes/slider-celular.webp")}
            />
            <img src={asset("imagenes/slider.webp")} alt="Warehouse" className="slider-bg" fetchPriority="high" width="1920" height="1003" />
          </picture>
          <div className="slider-overlay" aria-hidden="true"></div>
          <p className="slider-text">Pickeá, despachá, listo.</p>
        </section>

        <div className="section-marker" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>


        <section className="sobre-nosotros" id="nosotros">
          <div className="sobre-foto">
            <div className="oval oval-bottom"></div>
            <div className="oval oval-top"></div>
            <img src={asset("imagenes/trabajador.webp")} alt="Operario de depósito controlando stock y preparando pedidos con el sistema WMS de Voras" className="hombre-img" loading="lazy" width="450" height="641" />
          </div>
          <div className="sobre-contenido">
            <p className="sobre-titulo">Voras</p>
            <div className="sobre-texto">
              <p>Gestionar un depósito de e-commerce sin un WMS suele generar errores de inventario, pedidos mal preparados y operarios perdiendo tiempo. Cuando los pedidos crecen, las planillas y los procesos manuales hacen que la operación se vuelva lenta, desordenada y propensa a errores que terminan en devoluciones y clientes insatisfechos.</p>
              <p>&nbsp;</p>
              <p>Voras <strong>organiza tu depósito</strong>, <strong>optimiza el picking</strong> y <strong>sincroniza inventario</strong> en tiempo real para que prepares más pedidos en menos tiempo y con menos errores. El resultado: menos devoluciones, clientes más contentos y una marca que gana reputación a medida que tu operación crece.</p>
            </div>
          </div>
        </section>


        <section className="propuesta-valor" id="propuesta">
          <div className="section-header white">
            <div className="copete">
              <img src={asset("iconos/logo-blanco.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>BENEFICIOS</span>
            </div>
            <h2>Propuesta de valor</h2>
          </div>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>Tu estrategia logística</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Conectate con las principales empresas de logística, utilizando los acuerdos de precios que tengas con ellas.</p>
            </div>
            <div className="benefit-card">
              <h3>Inventario siempre preciso</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Cada movimiento queda registrado en tiempo real, evitando diferencias de stock, ventas de productos inexistentes y pérdidas de control del inventario.</p>
            </div>
            <div className="benefit-card">
              <h3>Menos errores y menos devoluciones</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Los procesos guiados y el uso de códigos de barras reducen errores de picking, lo que disminuye devoluciones, reclamos y costos operativos.</p>
            </div>
            <div className="benefit-card">
              <h3>Escalar sin perder control</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Permite manejar más pedidos, más productos y múltiples depósitos sin que la operación se vuelva caótica o dependiente de procesos manuales.</p>
            </div>
            <div className="benefit-card">
              <h3>Clientes más satisfechos y mejor reputación de marca</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Pedidos correctos, despachos más rápidos y menos problemas logísticos se traducen en mejores reseñas, clientes más contentos y una marca más confiable.</p>
            </div>
            <div className="benefit-card">
              <h3>Todos tus canales de venta integrados</h3>
              <div className="benefit-line"><img src={asset("iconos/linea.webp")} alt="" loading="lazy" width="128" height="1" /></div>
              <p>Centralizá los pedidos de todos tus canales de venta en un solo sistema, sincronizando inventario y operaciones para evitar sobreventas y simplificar la gestión logística.</p>
            </div>
          </div>
        </section>


        <section className="como-funciona" id="como-funciona">
          <div className="section-header">
            <div className="copete">
              <img src={asset("iconos/logo-azul.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>PASOS</span>
            </div>
            <h2>Cómo funciona</h2>
          </div>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">01</div>
              <h3>Ingresá la orden</h3>
              <p>Ingresá la orden de egreso al sistema, ya sea automáticamente por una integración, o un egreso manual.</p>
            </div>
            <div className="step-card">
              <div className="step-number">02</div>
              <h3>Orden de egreso</h3>
              <p>Los pickeadores de depósito seleccionan la orden de egreso, y la procesan pickeando los productos de dicha orden.</p>
            </div>
            <div className="step-card">
              <div className="step-number">03</div>
              <h3>Arman el pedido</h3>
              <p>Arman el pedido con los productos correspondientes, y le pegan la etiqueta de envío según el tipo de egreso que corresponda.</p>
            </div>
            <div className="step-card">
              <div className="step-number">04</div>
              <h3>Producto listo</h3>
              <p>El producto está listo para que sea retirado por el transporte o el cliente.</p>
            </div>
          </div>
        </section>


        <section className="demo-cta" id="demo">
          <div className="demo-content">
            <h2 className="demo-title">Vivilo en una demo</h2>
            <p className="demo-subtitle">Te mostramos en 20 minutos cómo Voras conecta tus tiendas, organiza el depósito y despacha en minutos. Sin compromiso, sin tarjeta.</p>
            <a href="/login" className="demo-btn" data-fb-event="Lead">
              <img src={asset("iconos/flecha.webp")} alt="" className="demo-arrow" loading="lazy" width="29" height="29" />
              <span>Agendar Demo</span>
            </a>
          </div>
          <div className="demo-visual">
            <div className="demo-circle"></div>
            <img src={asset("imagenes/mac.webp")} alt="Demostración de la interfaz del software WMS Voras en una MacBook" className="demo-macbook" loading="lazy" width="800" height="533" />
          </div>
        </section>


        <section className="funcionalidades" id="funcionalidades">
          <div className="section-header">
            <div className="copete">
              <img src={asset("iconos/logo-azul.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>BENEFICIOS</span>
            </div>
            <h2>Funcionalidades</h2>
          </div>
          <div className="features-wrap">
            <div className="features-row">
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/dashboard.webp")} alt="Icono de Dashboard Logístico" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Dashboard</h4>
                  <p>Con gráficos e información de tus pedidos y actividades.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/inventario.webp")} alt="Icono de Inventario" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Inventario</h4>
                  <p>Stock de todos tus productos.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/usuarios.webp")} alt="Icono de Gestión de Usuarios" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Usuarios</h4>
                  <p>Usuarios con diferentes roles y permisos.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/ecommerce.webp")} alt="Icono de Canales de Venta E-commerce" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Ecommerce</h4>
                  <p>Integrá tus canales de venta, y centralizá tu operativa.</p>
                </div>
              </div>
            </div>
            <div className="features-row">
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/envios.webp")} alt="Icono de Envíos y Paqueterías" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Envíos</h4>
                  <p>Conectate con las principales paqueterías.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/combos.webp")} alt="Icono de Combos de Productos" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Combos</h4>
                  <p>Tus combos pickeados correctamente, no te olvidas de enviar nada.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/qr.webp")} alt="Icono de Códigos de Barras" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Códigos</h4>
                  <p>Pickeo con código de barras.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/historial.webp")} alt="Icono de Historial de Stock" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Historial</h4>
                  <p>Historial de entrada y salida de stock de cada SKU.</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon-wrap">
                  <img src={asset("iconos/multibulto.webp")} alt="Icono de Productos Multibulto" loading="lazy" width="26" height="26" />
                </div>
                <div className="feature-text">
                  <h4>Multibulto</h4>
                  <p>Pickeás sin problemas productos compuestos por dos bultos o más.</p>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="integraciones" id="integraciones">
          <div className="section-header center">
            <div className="copete">
              <img src={asset("iconos/logo-azul.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>BENEFICIOS</span>
            </div>
            <h2>Integraciones</h2>
          </div>
          <div className="logos-grid">
            <img src={asset("integraciones/woo-commerce.webp")} alt="WooCommerce" className="integ-logo" width="134" height="33" style={{ height: "33px" }} loading="lazy" />
            <img src={asset("integraciones/mercado-libre.webp")} alt="Mercado Libre" className="integ-logo" width="118" height="29" style={{ height: "29px" }} loading="lazy" />
            <img src={asset("integraciones/tiendanube.webp")} alt="Tiendanube" className="integ-logo" width="169" height="29" style={{ height: "29px" }} loading="lazy" />
            <img src={asset("integraciones/andreani.webp")} alt="Andreani" className="integ-logo" width="169" height="29" style={{ height: "29px" }} loading="lazy" />
            <img src={asset("integraciones/urbano.webp")} alt="Urbano" className="integ-logo" width="99" height="31" style={{ height: "31px" }} loading="lazy" />
            <img src={asset("integraciones/enviopack.svg")} alt="Envíopack" className="integ-logo" width="145" height="29" style={{ height: "29px" }} loading="lazy" />
            <img src={asset("integraciones/epsa.webp")} alt="EPSA" className="integ-logo" width="85" height="38" style={{ height: "38px" }} loading="lazy" />
          </div>
        </section>


        <section className="planes" id="planes">
          <div className="section-header white">
            <div className="copete">
              <img src={asset("iconos/logo-blanco.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>PLANES</span>
            </div>
            <h2>Conocé nuestros planes</h2>
          </div>
          <div className="plan-toggle" role="group" aria-label="Ciclo de facturación">
            <button type="button" className={`plan-toggle-btn${!annual ? " is-active" : ""}`} onClick={() => setCycle("monthly")}>Mensual</button>
            <button type="button" className={`plan-toggle-btn${annual ? " is-active" : ""}`} onClick={() => setCycle("annual")}>Anual <span className="plan-toggle-badge">−20%</span></button>
          </div>
          <div className="plans-grid">
            <div className="plan-card">
              <div className="plan-badge">FREE</div>
              <div className="plan-price">$0<span className="plan-asterisk-light">*</span></div>
              <div className="plan-desc">
                <p>Incluye todas las funcionalidades.</p>
                <p>Hasta <strong>79</strong> egresos por mes.</p>
              </div>
              <p className="plan-usd">*USD</p>
              {/* Free no es una compra: reportarlo como InitiateCheckout con value 0
                  ensuciaba la optimización de campañas de Meta hacia Purchase. */}
              <button className="plan-btn" data-fb-event="StartTrial" data-plan="FREE">Elegir</button>
            </div>
            <div className="plan-card">
              <div className="plan-badge">STARTER</div>
              <div className="plan-price"><span className="plan-amount">{annual ? "$7,20" : "$9"}</span><span className="plan-asterisk">*</span></div>
              <div className="plan-cycle">por mes</div>
              <div className="plan-desc">
                <p>Incluye todas las funcionalidades.</p>
                <p>Hasta <strong>699</strong> egresos por mes.</p>
              </div>
              <p className="plan-usd">*USD</p>
              <button className="plan-btn" data-fb-event="InitiateCheckout" data-plan="STARTER" data-value="9">Elegir</button>
            </div>
            <div className="plan-card">
              <div className="plan-badge">STANDARD</div>
              <div className="plan-price"><span className="plan-amount">{annual ? "$12,80" : "$16"}</span><span className="plan-asterisk">*</span></div>
              <div className="plan-cycle">por mes</div>
              <div className="plan-desc">
                <p>Incluye todas las funcionalidades.</p>
                <p>Hasta <strong>1499</strong> egresos por mes.</p>
              </div>
              <p className="plan-usd">*USD</p>
              <button className="plan-btn" data-fb-event="InitiateCheckout" data-plan="STANDARD" data-value="16">Elegir</button>
            </div>
            <div className="plan-card">
              <div className="plan-badge">PROFESSIONAL</div>
              <div className="plan-price"><span className="plan-amount">{annual ? "$22,40" : "$28"}</span><span className="plan-asterisk">*</span></div>
              <div className="plan-cycle">por mes</div>
              <div className="plan-desc">
                <p>Incluye todas las funcionalidades.</p>
                <p>Hasta <strong>3299</strong> egresos por mes.</p>
              </div>
              <p className="plan-usd">*USD</p>
              <button className="plan-btn" data-fb-event="InitiateCheckout" data-plan="PROFESSIONAL" data-value="28">Elegir</button>
            </div>
            <div className="plan-card">
              <div className="plan-badge">ENTERPRISE</div>
              <div className="plan-price plan-price-text">A medida</div>
              <div className="plan-desc">
                <p>Incluye todas las funcionalidades.</p>
                <p>Desde <strong>3300</strong> egresos por mes.</p>
              </div>
              <p className="plan-usd">&nbsp;</p>
              {/* Enterprise es sales-led: el CTA lleva a hablar con una persona,
                  no a un checkout. Va como <a> para no romper ctrl+click ni el
                  anuncio de destino en lectores de pantalla. */}
              <a href="/contacto-ventas" className="plan-btn" data-fb-event="Contact" data-plan="ENTERPRISE">Hablar con un especialista</a>
            </div>
          </div>
          <p className="plans-tax-note"><strong>Precios en USD, netos de impuestos.</strong> Según tu país o medio de pago, tu banco o el emisor de tu tarjeta pueden aplicar IVA, percepciones u otros cargos sobre compras en el exterior.</p>
        </section>


        <section className="faqs" id="faqs">
          <div className="section-header center">
            <div className="copete">
              <img src={asset("iconos/logo-azul.webp")} alt="" className="logo-icon" loading="lazy" width="21" height="20" />
              <span>FAQs</span>
            </div>
            <h2>¿Tenés alguna duda?</h2>
          </div>
          <div className="faqs-columns">
            <div className="faqs-col">
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Qué es Voras WMS?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Voras es un sistema de gestión de depósitos diseñado para integrar todos tus canales de venta y procesar los pedidos minimizando errores y aumentando la productividad de tus operarios.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Para qué tipo de empresas está pensado Voras?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Está pensado para e-commerce, marcas que venden online y empresas que necesitan gestionar inventario y pedidos de forma eficiente.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Necesito tener un depósito grande para usar Voras?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>No. Voras funciona tanto para depósitos pequeños como para operaciones logísticas grandes.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Voras funciona con códigos de barras?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. El sistema está diseñado para trabajar con códigos de barras para controlar inventario, validar picking y reducir errores en la preparación de pedidos.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Se puede integrar con mi tienda online?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Voras puede integrarse con distintas plataformas de e-commerce para sincronizar pedidos e inventario automáticamente.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Qué canales de venta puede integrar Voras?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Voras puede centralizar pedidos provenientes de diferentes canales de venta como tiendas online, marketplaces y otros sistemas conectados.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Voras actualiza el inventario en tiempo real?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Cada movimiento dentro del depósito actualiza automáticamente el stock disponible para evitar sobreventas o diferencias de inventario.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Cuánto tiempo lleva implementar el sistema?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>La implementación suele ser rápida y puede realizarse en pocos días dependiendo del volumen de productos que tengas.</p>
                </div>
              </div>
            </div>
            <div className="faqs-col">
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Voras ayuda a reducir errores en los pedidos?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Los procesos guiados de picking y validación ayudan a disminuir significativamente los errores de preparación.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Puedo ver reportes y métricas de mi operación?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Voras permite analizar indicadores como productividad, movimientos de inventario y volumen de pedidos, entre otros.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Voras sirve para operaciones que están creciendo?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Está diseñado para escalar con el negocio, permitiendo manejar más pedidos, más productos y más ubicaciones sin perder control.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Se puede usar Voras con varios usuarios?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. El sistema permite múltiples usuarios con distintos roles y permisos dentro de la operación.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Necesito conocimientos técnicos para usar el sistema?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>No. Voras está diseñado para ser fácil de usar para operarios y equipos logísticos.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Voras funciona en la nube?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Sí. Es un sistema cloud, por lo que se puede acceder desde cualquier lugar con conexión a internet.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Qué soporte ofrecen?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>El equipo brinda soporte y acompañamiento durante la implementación y el uso del sistema.</p>
                </div>
              </div>
              <div className="faq-item">
                <button className="faq-question" type="button" aria-expanded="false"><span>¿Cómo puedo empezar a usar Voras?</span><span className="faq-icon">+</span></button>
                <div className="faq-answer">
                  <p>Podés solicitar una demo para ver cómo funciona el sistema y evaluar cómo puede adaptarse a tu operación logística. O bien loguearte y acceder a cualquiera de nuestros planes.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-empresa">
            <a href="/" className="footer-brand" aria-label="Voras">
              <img src={asset("iconos/logo-blanco.webp")} alt="Logotipo blanco de Voras" className="footer-logo-mark" loading="lazy" width="42" height="42" />
              <span className="footer-logo-text">Voras</span>
            </a>
            <p className="footer-copy">© 2026 Voras · Todos los derechos reservados</p>
            <p className="footer-copy">
              Un producto de Ficanaz LLC ·{" "}
              <a href="/terminos" style={{ color: "inherit", textDecoration: "underline" }}>Términos</a> ·{" "}
              <a href="/privacidad" style={{ color: "inherit", textDecoration: "underline" }}>Privacidad</a> ·{" "}
              <a href="/reembolsos" style={{ color: "inherit", textDecoration: "underline" }}>Reembolsos</a>
            </p>
            <div className="footer-social">
              <button type="button" className="social-icon" aria-label="LinkedIn">
                <span>in</span>
              </button>
              <a href="https://www.instagram.com/voras.io" className="social-icon" aria-label="Instagram">
                <span>ig</span>
              </a>
              <button type="button" className="social-icon" aria-label="WhatsApp">
                <span>wa</span>
              </button>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Voras</h4>
              <div className="footer-link-grid">
                <a href="#nosotros">Nosotros</a>
                <a href="#integraciones">Integraciones</a>
                <a href="#propuesta">Propuesta de valor</a>
                <a href="#planes">Planes</a>
                <a href="#como-funciona">Cómo funciona</a>
                <a href="#faqs">FAQs</a>
                <a href="#funcionalidades">Funcionalidades</a>
              </div>
            </div>
            <div className="footer-col">
              <h4>Contactanos</h4>
              <a href="#demo" className="footer-input-wrap footer-demo-link">
                <span className="footer-input">Agendar Demo</span>
                <span className="footer-send" aria-hidden="true">
                  <img src={asset("iconos/flecha.webp")} alt="Flecha" loading="lazy" width="18" height="18" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </footer>



  </div>
  );
};

export default LandingPage;
